<template>
  <scout-tab-panel
    :is-active="isActive"
    :title="title"
    name="reservation"
    :link="link"
    :tooltip="tooltip"
  />
</template>

<script>
import ScoutTabPanel from '@/components/atoms/ScoutTabPanel'
import { mapGetters } from 'vuex'

export default {
  components: {
    ScoutTabPanel
  },
  computed: {
    ...mapGetters([
      'isSendScout'
    ]),
    isActive () {
      return this.$route.path.includes('/reservation')
    },
    title () {
      return `スカウト予約の確認${this.isSendScout ? '・編集' : ''}`
    },
    link () {
      return { name: 'scoutReservation' }
    },
    tooltip () {
      return `スカウト予約の確認${this.isSendScout ? '、編集、削除' : ''}ができます。`
    }
  }
}
</script>
